import useSWR from 'swr';
import instance, { $POST } from './request';
import uploadInstance from '@cps/Upload/http';
import useSWRMutation from 'swr/mutation';
import { query } from '@/utils/const';
import { useNodes } from './useNodes';
import useUserStore, { sessionConfigCache } from '@/store/userStore';
import useMessageStore from '@/store/messageStore';
import { queryURLparams } from '@/utils';
import { userDevice } from '@/utils/const';
import { identityId } from '@/env';

export interface ISessionConfig {
  sessionId: string;
  token: string;
  uid: string;
}

export const useCreateChat = () => {
  const { getNodes } = useNodes();
  const userStore = useUserStore();

  const { data, isMutating, trigger } = useSWRMutation('/trans/session', async () => {
    const { getSessionConfig } = sessionConfigCache();
    const { sessionConfig } = getSessionConfig();

    const nodes = await getNodes();

    let nickId = '';
    if (query.nickId) {
      nickId = query.nickId;
    } else if (sessionConfig.nickId) {
      nickId = sessionConfig.nickId;
    }
    const resp = await $POST<any>(
      `/miner-api/trans/session`,
      {
        extraInfo: query.extraInfo || '',
        headIcon: query.headIcon || '',
        nickId,
        nickName: query.nickName,
        uid: '',
        language: query.language,
        email: query.email,
        phone: query.phone,
        source: query.source,
        groupID: query.groupID,
        device: userDevice,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          lbeSign: query.sign,
        },
      }
    ).catch(() => ({} as { code: number; data: ISessionConfig }));

    instance.interceptors.request.use((config) => {
      config.headers.lbeToken = resp.data.token;
      config.headers.lbeSign = query.sign;
      return config;
    });

    uploadInstance.interceptors.request.use((config) => {
      config.headers.lbeToken = resp.data.token;
      config.headers.lbeSign = query.sign;
      return config;
    });
    userStore.setSessionConfig(resp.data);

    return resp;
  });

  return {
    sessionConfig: data?.data,
    loading: isMutating,
    createSession: trigger,
  };
};

export const useSessionList = () => {
  const { nodes } = useNodes();
  const messagStore = useMessageStore();

  const { data, trigger, isMutating } = useSWRMutation('/trans/session-list', async () => {
    const resp = await $POST<any>(
      `/miner-api/trans/session-list`,
      {
        pagination: {
          pageNumber: 1,
          showNumber: 1000,
        },
        sessionType: 2,
        identityID: identityId,
      },
      undefined,
      {
        sessionList: [],
        Headers: {
          'Content-Type': 'application/json',
        },
      }
    ).catch(() => ({ data: { sessionList: [] } }));

    const newList = resp.data.sessionList.map((item: any) => {
      return { msgSeq: item.latestMsg.msgSeq, sessionId: item.sessionId };
    });

    messagStore.setSessionList(newList);

    return newList;
  });

  return {
    sessionList: data,
    getSessionList: trigger,
    isLoading: isMutating,
  };
};

export const useTimeoutConfig = () => {
  const userStore = useUserStore();

  const { data, isMutating, trigger } = useSWRMutation('/trans/session', async () => {
    const resp = await $POST<any>(
      `/miner-api/trans/timeout-config`,
      {
        userType: 2,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          lbeToken: query.sign,
        },
      }
    )
      .then((resp) => resp.data)
      .catch(() => ({ data: {} }));

    if (resp.isOpen) {
      userStore.setUserReplyCountdown(resp.timeout);
    } else {
      userStore.setUserReplyCountdown(0);
    }
    return resp;
  });

  useEffect(() => {
    trigger();
  }, []);

  return {
    data,
    isMutating,
    getTimeoutConfig: trigger,
  };
};
